<template>
  <div>
    <v-sheet
      tile
      height="54"
      color="grey lighten-3"
      class="d-flex"
    >
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        class="ma-2"
        label="type"
      ></v-select>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="value"
        :type="type"
        :events="events"
        :weekdays="weekday"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
      ></v-calendar>
    </v-sheet>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { Calendar } from 'dayspan';

@Component
class CalendarPage extends Vue {
  data() {
    return {
      calendar: Calendar.months(),
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      events: [],
      mode: 'stack',
      modes: ['stack', 'column'],
      type: 'month',
      types: ['month', 'week', 'day', '4day'],
      value: '',
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
    }
  }
}
export default CalendarPage;
</script>